import { create } from 'zustand';
import type { UserMember, TeamWithMembers } from '@scio3/shared-types';

export type AccountMembersDialogType =
  | 'inviteUser'
  | 'addUser'
  | 'changeRole'
  | 'assignTeamspace'
  | 'changeOwnerConfirm'
  | 'manageMembers'
  | 'addTeamspaceMembers'
  | 'resetPassword'
  | 'manageRoles'
  | 'addRole'
  | 'teamDialog'
  | null;

interface AccountMembersDialogContext {
  /** Member being acted on (change role, reset password, etc.) */
  member?: UserMember;
  /** Team context for team-scoped operations */
  team?: TeamWithMembers;
  /** Team ID for operations that only need the ID */
  teamId?: string;
  /** Custom role ID for editing existing roles */
  roleId?: string;
}

interface AccountMembersDialogState {
  activeDialog: AccountMembersDialogType;
  dialogContext: AccountMembersDialogContext;
  parentDialog: AccountMembersDialogType;
  parentContext: AccountMembersDialogContext;
  openDialog: (dialog: AccountMembersDialogType, context?: AccountMembersDialogContext) => void;
  openChildDialog: (
    dialog: AccountMembersDialogType,
    context?: AccountMembersDialogContext,
  ) => void;
  closeDialog: () => void;
}

export const useAccountMembersDialogStore = create<AccountMembersDialogState>((set) => ({
  activeDialog: null,
  dialogContext: {},
  parentDialog: null,
  parentContext: {},
  openDialog: (activeDialog, dialogContext = {}) =>
    set({ activeDialog, dialogContext, parentDialog: null, parentContext: {} }),
  openChildDialog: (dialog, context = {}) =>
    set((state) => ({
      activeDialog: dialog,
      dialogContext: context,
      parentDialog: state.activeDialog,
      parentContext: state.dialogContext,
    })),
  closeDialog: () =>
    set((state) => {
      if (state.parentDialog) {
        return {
          activeDialog: state.parentDialog,
          dialogContext: state.parentContext,
          parentDialog: null,
          parentContext: {},
        };
      }
      return { activeDialog: null, dialogContext: {}, parentDialog: null, parentContext: {} };
    }),
}));
